import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Produkt } from '../../models/produkt.model';
import {ProdukteDataService} from "../../../settings/services/produkte/produkte-data.service";

@Component({
    selector: 'app-produkte-autocomplete',
    templateUrl: './produkte-autocomplete.component.html',
    styleUrls: ['./produkte-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProdukteAutocompleteComponent implements OnInit, OnChanges {
    @Input() sortiment: Produkt[];
    
    ngOnChanges(changes: SimpleChanges) {
        if (changes['sortiment'] && this.sortiment) {
            this.sortiment = this.sortiment.slice().sort((a, b) => a.name.localeCompare(b.name));
        }
    }
    
    @Output() productAdded: EventEmitter<Produkt> = new EventEmitter<Produkt>();
    @Output() productRemoved: EventEmitter<Produkt> = new EventEmitter<Produkt>();
    @Output() productCreated: EventEmitter<Produkt> = new EventEmitter<Produkt>();
    @ViewChild('productAutoComplete', { static: true }) productAutoComplete;
    allProducts: Produkt[] = [];
    filteredProductsMultiple: Produkt[] = [];

    constructor(private produkteDataService: ProdukteDataService) {
    }

    ngOnInit() {
       this.loadAllProducts();
    }

    loadAllProducts() {
        this.produkteDataService.getProdukte()
        .subscribe(produkte => {
            this.allProducts = produkte;
        });
    }

    filterProductsMultiple(event) {
        const productsToFilter = this.allProducts.filter(p => this.sortiment.find(s => s.id === p.id) == null)
        this.filteredProductsMultiple = productsToFilter.filter(p => p.name.toLowerCase().startsWith(event.query.toLowerCase()));
    }


    createNewProduct(productName: string) {
        if (!productName) {
            return;
        }

        this.produkteDataService.createNewProduct(new Produkt(productName))
            .subscribe((product) => {
                this.sortiment = [...this.sortiment, product];
                this.productAutoComplete.modelValue.set(this.sortiment);
                this.productAutoComplete.inputValue = '';
                if (this.productAutoComplete.multiInputEl?.nativeElement) {
                    this.productAutoComplete.multiInputEl.nativeElement.value = '';
                }
                this.productAdded.emit(product);
                this.loadAllProducts();
            });
    }

    removeProduct(removedProduct: Produkt) {
        this.productRemoved.emit(removedProduct);
    }

    assignExistingProduct(productToAssign: Produkt) {
        this.productAdded.emit(productToAssign);
    }

}
